var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 245.8 215.1",
    style: {
      enableBackground: "new 0 0 245.8 215.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#332A88;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.3,46.1c6.7,0,12.5,2.2,17.3,6.7c4.8,4.5,7.2,9.9,7.2,16.3V192c0,6.4-2.4,11.8-7.2,16.3 c-4.8,4.5-10.6,6.7-17.3,6.7H30.7c-8.6,0-15.9-3-21.8-8.9C3,200.3,0,193,0,184.4V30.7c0-8.6,3-15.9,8.9-21.8C14.8,3,22.1,0,30.7,0 h176.7c6.4,0,11.8,2.2,16.3,6.7c4.5,4.5,6.7,9.9,6.7,16.3c0,2.2-0.7,4.1-2.2,5.5c-1.4,1.4-3.3,2.2-5.5,2.2H38.4 c-2.2,0-4.1,0.7-5.5,2.2c-1.4,1.4-2.2,3.3-2.2,5.5c0,2.2,0.7,4.1,2.2,5.5s3.3,2.2,5.5,2.2H221.3z M188.9,141.4 c3,3,6.6,4.6,10.8,4.6c4.2,0,7.8-1.5,10.8-4.6c3-3,4.6-6.6,4.6-10.8c0-4.2-1.5-7.8-4.6-10.8c-3-3-6.6-4.6-10.8-4.6 c-4.2,0-7.8,1.5-10.8,4.6c-3,3-4.6,6.6-4.6,10.8C184.4,134.8,185.9,138.4,188.9,141.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.5fe268dde4b6f746bec54fd07c28a37a.svg";
export { ForwardRef as ReactComponent };